import {LanguageBaseView} from "../../LanguageModel/view/LanguageBaseView";
import {FileBaseView} from "../../FileModel/view/FileBaseView";
import {AffiliateBaseView} from "../../AffiliateModel/view/AffiliateBaseView";
import {CountryBaseView} from "../../CountryModel/view/CountryBaseView";
import {CompanyValidatedBaseView} from "../../CompanyValidatedModel/view/CompanyValidatedBaseView";
import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";


/**
 * @Deprecated
 */
export class MemberForPartnerEditView {

    id: number;
    email: string;
    userGroupName: string;
    userGroupId: number;
    loginId: string;
    company: CompanyView;
    languageModel: LanguageBaseView;
    firstName: string;
    lastName: string;
    prefixe: number;
    portFolio: FileBaseView[];
    affiliateModel: AffiliateBaseView;
    promoOptOut: boolean;
    status: number;
    partnerRfpCount: number;
    newContactInfosData: string;
    newContactInfos: boolean


    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.email = data?.email ?? ""
        this.userGroupName = data?.userGroupName ?? ""
        this.userGroupId = data?.userGroupId ?? 0
        this.loginId = data?.loginId ?? ""
        this.company = data?.company ?? new CompanyView()
        this.languageModel = data?.languageModel ?? new LanguageBaseView()
        this.firstName = data?.firstName ?? ""
        this.lastName = data?.lastName ?? ""
        this.prefixe = data?.prefixe ?? 0
        this.portFolio = data?.portFolio ?? []
        this.affiliateModel = data?.affiliateModel ?? new AffiliateBaseView()
        this.promoOptOut = data?.promoOptOut ?? false
        this.status = data?.status ?? 0
        this.partnerRfpCount = data?.partnerRfpCount ?? 0
        this.newContactInfosData = data?.newContactInfosData ?? ""
        this.newContactInfos = data?.newContactInfos ?? false
    }
}


class CompanyView {

    id: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    state: string;
    country: CountryBaseView
    regionName: string;
    phone: string;
    mobil: string;
    telValidated: CompanyValidatedBaseView[];
    website: string;
    tva: string;
    vatExempted: boolean;
    logo: string;
    companyType: string;
    department: string;
    function: string;
    juridicalFormModel: JuridicalFormView;
    differentInvoiceAddress: boolean;
    officeName: string;
    officeContactPerson: string;
    officeAddress1: string;
    officeAddress2: string;
    officeCity: string;
    officeState: string;
    officeZip: string;
    officeCountry: CountryBaseView;
    industryArea: IndustryAreaView;
    dateCreation: Date;
    numberOfEmployees: number;
    bankModels: BankView[];
    faxNumber: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
        this.address1 = data?.address1 ?? ""
        this.address2 = data?.address2 ?? ""
        this.city = data?.city ?? ""
        this.zipCode = data?.zipCode ?? ""
        this.state = data?.state ?? ""
        this.country = data?.country ?? new CountryBaseView()
        this.regionName = data?.regionName ?? ""
        this.phone = data?.phone ?? ""
        this.mobil = data?.mobil ?? ""
        this.telValidated = data?.telValidated ?? []
        this.website = data?.website ?? ""
        this.tva = data?.tva ?? ""
        this.vatExempted = data?.vatExempted ?? false
        this.logo = data?.logo ?? ""
        this.companyType = data?.companyType ?? ""
        this.department = data?.department ?? ""
        this.function = data?.function ?? ""
        this.juridicalFormModel = data?.juridicalFormModel ?? ""
        this.differentInvoiceAddress = data?.differentInvoiceAddress ?? false
        this.officeName = data?.officeName ?? ""
        this.officeContactPerson = data?.officeContactPerson ?? ""
        this.officeAddress1 = data?.officeAddress1 ?? ""
        this.officeAddress2 = data?.officeAddress2 ?? ""
        this.officeCity = data?.officeCity ?? ""
        this.officeState = data?.officeState ?? ""
        this.officeZip = data?.officeZip ?? ""
        this.officeCountry = data?.officeCountry ?? new CountryBaseView()
        this.industryArea = data?.industryArea ?? new IndustryAreaView()
        this.dateCreation = data?.dateCreation ?? new Date()
        this.numberOfEmployees = data?.numberOfEmployees ?? 0
        this.bankModels = data?.bankModels ?? []
        this.faxNumber = data?.faxNumber ?? ""
    }
}

class IndustryAreaView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
    }
}


class JuridicalFormView {


    id: number;
    country: CountryBaseView;
    name: MessageBaseView;
    shortName: MessageBaseView;



    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.country = data?.language ?? null;
        this.name = data?.name ?? "";
        this.shortName = data?.shortName ?? "";
    }


}


class BankView {
    id: number;
    bic: string;
    iban: string;
    typeMandate: number;
    mandateId: string;
    inviteUrl: string;
    status: number;
    country: CountryBaseView;

    constructor(data: any) {
        this.id = data?.id ?? 0
        this.bic = data?.bic ?? "";
        this.iban = data?.iban ?? "";
        this.typeMandate = data?.typeMandate ?? 0;
        this.mandateId = data?.mandateId ?? "";
        this.inviteUrl = data?.inviteUrl ?? "";
        this.status = data?.status ?? 0;
        this.country = data?.country ?? new CountryBaseView()
    }
}
